import * as z from 'zod';

import { emailSchema } from '@/_schemas/generic';

export const emailQuerySchema = z.object({
  id: z.number(),
  email: emailSchema(),
  pivot: z.object({
    default: z.number(),
  }),
  // extra fields
  intent: z.union([z.literal('create'), z.literal('delete'), z.literal('update')]).optional(),
  // localMatchId is used to match email in create case
  localMatchId: z.number().optional(),
  // helps when add new email in update list
  setDirtyHelper: z.boolean().optional(),
});
export type EmailQuerySchema = z.infer<typeof emailQuerySchema>;
export const emailsQuerySchema = z.array(emailQuerySchema);

export const emailCreateFormSchema = emailQuerySchema;
export type EmailCreateFormSchema = z.infer<typeof emailCreateFormSchema>;

export const emailFormSchema = emailQuerySchema.omit({ email: true }).extend({
  email: emailSchema(false),
});

export type EmailFormSchema = z.infer<typeof emailFormSchema>;

// let duplicateEmailPlaces: string[] = [];
export const dummyEmailsQuerySchema = z
  .object({
    emails: z.array(emailFormSchema),
  })
  .superRefine(({ emails }, ctx) => {
    const places: string[] = [];
    const emailCounts = emails.reduce(
      (acc, email, index) => {
        if (!acc[email.email]) {
          acc[email.email] = [];
        }
        acc[email.email].push(index);
        return acc;
      },
      {} as Record<string, number[]>
    );

    const duplicateIndexes = Object.values(emailCounts)
      .filter((indexes) => indexes.length > 1)
      .flat();
    places.push(...duplicateIndexes.map((index) => index.toString()));
    for (let i = 0; i < places.length; i++) {
      ctx.addIssue({
        code: 'custom',
        message: 'Email already exists.',
        fatal: true,
        path: [`emails.${places[i]}.email`],
      });
    }
  });

export const emailsMutationSchema = emailQuerySchema.pick({ email: true, id: true });
export type EmailsMutationSchema = z.infer<typeof emailsMutationSchema>;

export const emailsLinkerMutationSchema = z.array(
  z.object({
    id: z.number(),
    default: z.boolean(),
  })
);

export function hasDuplicates(a: string[]) {
  const noDups = new Set(a);
  return a.length !== noDups.size;
}
